export const USER_VERIFICATION_CHECKLIST_FORM = 'USER_VERIFICATION_CHECKLIST_FORM';
export const ACCOUNT_VERIFICATION_CHECKLIST_FORM = 'ACCOUNT_VERIFICATION_CHECKLIST_FORM';

export const VERIFICATION_CHECK_QUESTION_TYPES = {
  NEW_ACCOUNT: 'New Account',
  ADDITIONAL_ACCOUNT: 'Additional Account',
};

export const VERIFICATION_CHECKLIST_MODAL = 'VERIFICATION_CHECKLIST_MODAL';
